import React, { ReactNode, useRef, useState } from "react";

import { getDocument } from "../../../api/documents";
import { Link } from "../../../components/links/Link";
import { translateDocumentType } from "../translateDocumentType";
import styles from "./PolicyDocumentDownloadLink.module.scss";

interface Props {
  id: string;
  policyNumber: string;
  productCode: string | null;
  children: ReactNode;
  letterDate: string;
  type: string;
}

export const PolicyDocumentDownloadLink = ({ id, policyNumber, children, productCode, letterDate, type }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const timerRef = useRef<number>();

  const handleDownload = async () => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      setHasError(false);

      const doc = await getDocument(policyNumber, id, productCode);

      const linkSource = `data:application/pdf;base64,${doc.fileContent}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = `${translateDocumentType(type)} ${letterDate}`;
      downloadLink.click();
      downloadLink.remove();
    } catch (e) {
      setHasError(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = window.setTimeout(() => {
        setHasError(false);
      }, 2000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {hasError && (
        <span className={styles.policyDocumentDownloadLink_error}>
          Het is niet mogelijk om het bestand te downloaden, probeer het later nog eens
        </span>
      )}
      {!hasError && (
        <Link id={id} onClick={handleDownload} loading={isLoading} leading={<i className={`icon icon-download`} />}>
          {children}
        </Link>
      )}
    </>
  );
};
